import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { HttpService } from './http.service';
import { NOTIFICATION_SEVERITY, NOTIFICATION_SUMMARY, } from '@qts-sdp-ui/shared-data';
import * as i0 from "@angular/core";
import * as i1 from "./http.service";
export class NotificationService {
    constructor(httpService) {
        this.httpService = httpService;
        this.notification = new Subject();
        this.notification$ = this.notification.asObservable();
        this.subscriptionHolder = new Subscription();
        this.subscriptionHolder.add(this.httpService.errorReceived$.subscribe((err) => {
            this.addApiErrorMessage(err);
        }));
    }
    add(message) {
        this.notification.next(message);
    }
    showSuccess(message) {
        this.add({
            severity: NOTIFICATION_SEVERITY.SUCCESS,
            summary: NOTIFICATION_SUMMARY.SUCCESS,
            ...message,
        });
    }
    showError(message) {
        this.add({
            severity: NOTIFICATION_SEVERITY.ERROR,
            summary: NOTIFICATION_SUMMARY.ERROR,
            ...message,
        });
    }
    showInfo(message) {
        this.add({
            severity: NOTIFICATION_SEVERITY.INFO,
            summary: NOTIFICATION_SUMMARY.INFO,
            ...message,
        });
    }
    showWarning(message) {
        this.add({
            severity: NOTIFICATION_SEVERITY.WARNING,
            summary: NOTIFICATION_SUMMARY.WARNING,
            ...message,
        });
    }
    addApiErrorMessage(err) {
        this.showError({
            sticky: false,
            detail: err?.error?.message ||
                err?.message ||
                'System Error: Could not complete your request.',
        });
    }
    clear() {
        this.notification.next({});
    }
    ngOnDestroy() {
        this.subscriptionHolder.unsubscribe();
    }
    static { this.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(i0.ɵɵinject(i1.HttpService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NotificationService, factory: NotificationService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [{ type: i1.HttpService }], null); })();
